"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = void 0;
var tslib_1 = require("tslib");
var _ = require("lodash");
var child_process_1 = require("child_process");
var axios_1 = require("axios");
var uuid = require("uuid");
var os = require("os");
var crypto = require("crypto");
var moment = require("moment-timezone");
var fs = require("fs");
var Path = require("path");
var big_js_1 = require("big.js");
var string_decoder_1 = require("string_decoder");
var WrappedError_1 = require("./WrappedError");
var Holidays_1 = require("./Holidays");
var amorphic_1 = require("@haventech/amorphic");
var Ctx_1 = require("./Ctx");
var _templatePath = __dirname + '/../../workflow/templates/';
var COUNTRY_US = 'US';
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Object.defineProperty(Utils, "ctx", {
        get: function () {
            return this._ctx || (this._ctx = Ctx_1.Ctx.get);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Utils, "logger", {
        get: function () {
            return Ctx_1.Ctx.get.logger(Utils.name);
        },
        enumerable: false,
        configurable: true
    });
    Utils.toMilliseconds = function (unit) {
        unit = unit || 'ms';
        if (unit.match(/^secs?$/)) {
            return 1e3;
        }
        if (unit.match(/^mins?$/)) {
            return 6e4;
        }
        if (unit.match(/^hrs?$/)) {
            return 36e5;
        }
        if (unit.match(/^days?$/)) {
            return 864e5;
        }
        return 1;
    };
    Utils.denyRequest = function (res, message) {
        this.writeResponse(res, 405, message);
    };
    // Generic HTTP response method
    Utils.writeResponse = function (res, resCode, json) {
        res.writeHead(resCode, { 'Content-Type': 'application/json' });
        res.end(JSON.stringify(json));
    };
    Utils.getStrForGoogleMapAPI = function (name, ext) {
        return amorphic_1.amorphicStatic.config.nconf.get(name + ext);
    };
    Utils.getRunMode = function () {
        return amorphic_1.amorphicStatic.config.nconf.get('runMode') || '';
    };
    Utils.isRunMode = function (mode, subMode, subModes) {
        var regex, modeSpec = '';
        if (subMode) {
            regex = new RegExp('^\\s*' + mode + '\\s*:([\\w-]*\\s+)*' + subMode + '(\\s+[\\w-]*)*$', 'i');
            if (subModes && subModes.match(/^\s*!/)) {
                modeSpec = mode + ': ' + subModes.replace(/^\s*!\s*/, '');
            }
            else if (subModes && subModes.match(/^\s*\+/)) {
                modeSpec = Utils.getRunMode() + ' ' + subModes.replace(/^\s*\+\s*/, '');
            }
            else {
                modeSpec = Utils.getRunMode();
            }
        }
        else {
            regex = new RegExp('^\\s*' + mode, 'i');
            modeSpec = Utils.getRunMode() || '';
        }
        return modeSpec.match(regex);
    };
    Utils.echo = function (value) {
        return value;
    };
    Utils.exists = function (value) {
        return value !== undefined && value !== null && value !== '';
    };
    Utils.extend = function (obj) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (obj) {
            Array.prototype.slice.call(args, 0).forEach(function (source) {
                if (source) {
                    for (var prop in source) {
                        if (source[prop] instanceof Object && obj[prop] instanceof Object) {
                            _this.extend(obj[prop], source[prop]);
                        }
                        else {
                            var descriptor = Object.getOwnPropertyDescriptor(source, prop);
                            if (descriptor) {
                                Object.defineProperty(obj, prop, descriptor);
                            }
                            else {
                                throw "descriptor is undefined for prop: ".concat(prop, " and obj: ").concat(obj);
                            }
                        }
                    }
                }
            });
        }
        return obj;
    };
    Utils.asyncMap = function (arr, concurrency, callback) {
        var cnt = arr.length / concurrency;
        var p = Promise.resolve([]);
        var start = 0;
        for (var i = 0; i < cnt; i++) {
            p = p.then(function (results) {
                var end = start + concurrency;
                return Promise.all(arr.slice(start, end).map(callback))
                    .then(function (eRes) {
                    start = end;
                    results.push.apply(results, eRes);
                    return results;
                });
            });
        }
        return p;
    };
    Utils.listenToShutdownSignals = function (shutdownHandler) {
        if (shutdownHandler) {
            Utils._shutdownHandlers.push(shutdownHandler);
        }
        if (Utils._listeningToShutdownSignals) {
            return;
        }
        Utils._listeningToShutdownSignals = true;
        ['SIGHUP', 'SIGINT', 'SIGQUIT', 'SIGABRT', 'SIGTERM'].forEach(function (signal) {
            process.on(signal, function () {
                Utils.logger.info('listenToShutdownSignals', 'Shutdown triggered by ' + signal, signal);
                Promise.all(Utils._shutdownHandlers.map(function (handler) {
                    return handler();
                })).then(function () {
                    setTimeout(function () {
                        // Allow logs to complete
                        process.exit(1);
                    }, 1e3);
                });
            });
        });
    };
    Utils.getParsedGeolocationUrl = function (url, country, zip) {
        /* Regexp splits url "https://maps.googleapis.com/maps/api/geocode/json?components=country:{0}|postal_code:{1}" splits into  following 4 groups
                https://maps.googleapis.com/maps/api/geocode/json?components=country:
                {0}
                |postal_code:
                {1}
         */
        if (!zip) {
            url = url.replace(/(.*)(\{\d\})(.*)(\{\d\})/, "$1".concat(country));
        }
        else if (country === COUNTRY_US) {
            var zipcodeFiveDigit = Utils.formatFiveDigitZipcode(zip);
            url = url.replace(/(.*)(\{\d\})(.*)(\{\d\})/, "$1".concat(country, "$3").concat(zipcodeFiveDigit));
        }
        else {
            url = url.replace(/(.*)(\{\d\})(.*)(\{\d\})/, "$1".concat(country, "$3").concat(zip));
        }
        return url;
    };
    Utils.getGeolocation = function (zip, country) {
        var zipcodeFiveDigit = Utils.formatFiveDigitZipcode(zip);
        var geoLocationAPIUrl = Utils.getStrForGoogleMapAPI(Utils.GEOLOCATION_API_NAME, 'Url');
        geoLocationAPIUrl = this.getParsedGeolocationUrl(geoLocationAPIUrl, country, zip);
        var key = Utils.getStrForGoogleMapAPI(Utils.GEOLOCATION_API_NAME, 'Key_' + amorphic_1.amorphicStatic.config.nconf.get('APPLICATION'));
        if (!key) {
            key = Utils.getStrForGoogleMapAPI(Utils.GEOLOCATION_API_NAME, 'Key');
        }
        if (key) {
            geoLocationAPIUrl += '&key=' + key; // Add API Key for Google Request.
        }
        Utils.logger.info('getGeolocation', 'Making ZIP Google API Request', {
            zipcode: zipcodeFiveDigit,
            geoLocationAPIUrl: geoLocationAPIUrl
        });
        return axios_1.default.get(geoLocationAPIUrl).then(parseResponse);
        function parseResponse(resp) {
            var body = resp.data;
            if (body.status !== 'OK') {
                handleBadResponse(body);
            }
            var geoLocation = {};
            Utils.logger.debug('getGeolocation', "Retrieved geolocation data from Google API for country ".concat(country, " and zip ").concat(zip), {
                zipcode: zipcodeFiveDigit,
                country: country
            });
            var loc = getCityStateCountry(body);
            if (loc.country === COUNTRY_US) {
                geoLocation.stateCode = loc.state;
                geoLocation.city = loc.city;
            }
            geoLocation.lat = getLatitude(body);
            geoLocation.lng = getLongitude(body);
            return geoLocation;
        }
        function getCityStateCountry(body) {
            var loc = {
                city: null,
                state: null,
                country: null
            };
            body.results[0].address_components.forEach(function (element) {
                if (element.types.indexOf('country') > -1) {
                    loc.country = element.short_name;
                }
                else if (element.types.indexOf('administrative_area_level_1') > -1) {
                    loc.state = element.short_name;
                }
            });
            if (loc.country === COUNTRY_US && loc.state) {
                // Get city from formatted_address
                var addressTokens = body.results[0].formatted_address.split(',');
                if (addressTokens.length >= 3) {
                    loc.city = addressTokens.reverse()[2].trim();
                }
            }
            return loc;
        }
        function getLatitude(body) {
            return body.results[0].geometry.location.lat;
        }
        function getLongitude(body) {
            return body.results[0].geometry.location.lng;
        }
        function handleBadResponse(body) {
            Utils.logger.warn('getGeolocation', 'Unable to retrieve valid geolocation data from Google API for ZIP', {
                zipcode: zipcodeFiveDigit,
                status: body.status
            });
            throw new Error('Unable to retrieve geolocation for ' + zipcodeFiveDigit);
        }
    };
    Utils.getTimezone = function (latitude, longitude) {
        var secs = new Date().getTime() / 1e3;
        var timezoneAPIUrl = Utils.getStrForGoogleMapAPI(Utils.TIMEZONE_API_NAME, 'Url') + (latitude + ',' + longitude) + '&timestamp=' + secs;
        var key = Utils.getStrForGoogleMapAPI(Utils.TIMEZONE_API_NAME, 'Key_' + amorphic_1.amorphicStatic.config.nconf.get('APPLICATION'));
        if (!key) {
            key = Utils.getStrForGoogleMapAPI(Utils.TIMEZONE_API_NAME, 'Key');
        }
        if (key) {
            timezoneAPIUrl += '&key=' + key; // Add API Key for Google Request.
        }
        Utils.logger.info('getTimezone', 'Making Timezone Google API Request', {
            latitude: latitude,
            longitude: longitude,
            timezoneAPIUrl: timezoneAPIUrl
        });
        return axios_1.default.get(timezoneAPIUrl).then(function (resp) {
            var data = resp.data;
            if (data.status === 'OK') {
                Utils.logger.info('getTimezone', 'Retrieved timezone data from Google API for lat/lng', {
                    latitude: latitude,
                    longitude: longitude,
                    timezone: data.timeZoneId
                });
                return data.timeZoneId;
            }
            throw new Error('Unable to retrieve timezone for (' + latitude + ', ' + longitude + ')');
        });
    };
    Utils.now = function () {
        return Utils._currentTimeOffset ? new Date(Date.now() + Utils._currentTimeOffset) : new Date();
    };
    Utils.milliseconds = function (value, unit) {
        return value * Utils.toMilliseconds(unit);
    };
    Utils.getPreviousDate = function (date) {
        date.setDate(date.getDate() - 1);
        return date;
    };
    Utils.getYesterday = function () {
        return this.getPreviousDate(this.now());
    };
    Utils.offsetCurrentTime = function (offset, unit) {
        return Utils.offsetTime(Utils.now(), offset, unit);
    };
    Utils.offsetTime = function (date, offset, unit) {
        return new Date(date.getTime() + offset * Utils.toMilliseconds(unit));
    };
    Utils.timeDiff = function (dt1, dt2, unit) {
        return (Number(dt1) - Number(dt2)) / Utils.toMilliseconds(unit);
    };
    Utils.offsetDate = function (date, offset, unit) {
        var newDate = new Date(date.getTime());
        if (unit.match(/^days?$/)) {
            newDate.setUTCDate(date.getUTCDate() + offset);
        }
        else if (unit.match(/^months?$/)) {
            newDate.setUTCMonth(date.getUTCMonth() + offset);
        }
        else if (unit.match(/^years?$/)) {
            newDate.setUTCFullYear(date.getUTCFullYear() + offset);
        }
        // if we roll dates from one TZ offset to another (EDT -> EST or vice versa)
        // and the hour on the date is on the boundary, need to roll that hour,
        // or the new date will be off by one day
        var tzDiff = newDate.getTimezoneOffset() - date.getTimezoneOffset();
        if (tzDiff !== 0) {
            newDate.setUTCMinutes(date.getUTCMinutes() + tzDiff);
        }
        return newDate;
    };
    Utils.dateToIsoObj = function (date) {
        if (date) {
            var dt = date.toISOString().split('T');
            return {
                date: dt[0],
                time: dt[1]
            };
        }
        return {
            date: null,
            time: null
        };
    };
    Utils.isoToDate = function (dtStr, timeStr) {
        if (!dtStr) {
            return null;
        }
        if (timeStr) {
            dtStr += 'T' + timeStr;
            return new Date(dtStr);
        }
        var momentDate = moment(dtStr, "YYYY-MM-DDTHH:mm:ss.SSSZ", true);
        if (momentDate.isValid()) {
            return momentDate.toDate();
        }
        return null;
    };
    Utils.mdyToDate = function (dtStr) {
        if (!dtStr) {
            return null;
        }
        var dtParts = dtStr.split(/[\/\-]/);
        return new Date(Date.UTC(Number(dtParts[2]), Number(dtParts[0]) - 1, Number(dtParts[1])));
    };
    Utils.ymdToDate = function (dtStr) {
        if (!dtStr) {
            return null;
        }
        var dtParts = dtStr.split(/[\/\-]/);
        return new Date(Date.UTC(Number(dtParts[0]), Number(dtParts[1]) - 1, Number(dtParts[2])));
    };
    Utils.getMonthEndDate = function (date) {
        var monthEndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return monthEndDate;
    };
    Utils.getMonthStartDate = function (date) {
        var monthStartDate = new Date(date.getFullYear(), date.getMonth(), 1);
        return monthStartDate;
    };
    Utils.tzDate = function (date, timezone) {
        return {
            dt: function () {
                if (date) {
                    return timezone ? moment(date).tz(timezone) : moment(date);
                }
                return date;
            }(),
            toDate: function () {
                return this.dt ? this.dt.toDate() : null;
            },
            getDate: function () {
                return this.dt ? this.dt.date() : null;
            },
            setDate: function (dayOfMonth) {
                this.dt ? this.dt.date(dayOfMonth) : null;
            },
            timezoneOffset: function () {
                return this.dt ? this.dt.utcOffset() : null;
            },
            format: function (fmt) {
                return this.dt ? this.dt.format(fmt) : '';
            },
            toMdy: function () {
                return this.format('L');
            },
            toMy: function (separator) {
                separator = separator || '/';
                return this.format('MM' + separator + 'YYYY');
            },
            toMdyHm: function () {
                return this.format('L LT');
            },
            toYmd: function (separator) {
                separator = separator || '-';
                return this.format('YYYY' + separator + 'MM' + separator + 'DD');
            }
        };
    };
    Utils.dateToMdy = function (date) {
        return date && date.dt ? date.toMdy() : Utils.tzDate(date).toMdy();
    };
    Utils.dateToMY = function (date) {
        return date && date.dt ? date.toMy() : Utils.tzDate(date).toMy();
    };
    Utils.dateToMdyHm = function (date) {
        return date && date.dt ? date.toMdyHm() : Utils.tzDate(date).toMdyHm();
    };
    Utils.dateToYmd = function (date) {
        return date && date.dt ? date.toYmd() : Utils.tzDate(date).toYmd();
    };
    Utils.yearsBetween = function (fromDate, toDate, opts) {
        var _a;
        if (opts === void 0) { opts = {}; }
        var negative = opts.notAbsolute && fromDate > toDate;
        if (fromDate > toDate) {
            _a = [fromDate, toDate], toDate = _a[0], fromDate = _a[1];
        }
        var toYear = toDate.getUTCFullYear();
        var toMonth = toDate.getUTCMonth();
        var toDay = toDate.getUTCDate();
        var toHour = toDate.getUTCHours();
        var toMinutes = toDate.getUTCMinutes();
        var toSeconds = toDate.getUTCSeconds();
        var toMillis = toDate.getUTCMilliseconds();
        var fromYear = fromDate.getUTCFullYear();
        var fromMonth = fromDate.getUTCMonth();
        var fromDay = fromDate.getUTCDate();
        var fromHour = fromDate.getUTCHours();
        var fromMinutes = fromDate.getUTCMinutes();
        var fromSeconds = fromDate.getUTCSeconds();
        var fromMillis = fromDate.getUTCMilliseconds();
        fromDay = opts.ignoreLeapDays && fromMonth === 1 && fromDay === 29 ? 28 : fromDay;
        var subtractYear = true;
        var sameMonth = fromMonth === toMonth;
        var sameDay = sameMonth && fromDay === toDay;
        var sameHour = sameDay && fromHour === toHour;
        var sameMinute = sameHour && fromMinutes === toMinutes;
        var sameSecond = sameMinute && fromSeconds === toSeconds;
        if ((fromYear === toYear) ||
            (fromMonth < toMonth) ||
            (sameMonth && fromDay < toDay) ||
            (sameDay && !opts.subDayPrecision) ||
            (sameDay && fromHour < toHour) ||
            (sameHour && fromMinutes < toMinutes) ||
            (sameMinute && fromSeconds < toSeconds) ||
            (sameSecond && fromMillis <= toMillis)) {
            subtractYear = false;
        }
        var result = subtractYear ? toYear - fromYear - 1 : toYear - fromYear;
        return negative ? result * -1 : result;
    };
    Utils.timeBetween = function (fromDate, toDate, unit) {
        var _a;
        if (fromDate > toDate) {
            _a = [fromDate, toDate], toDate = _a[0], fromDate = _a[1];
        }
        return Math.trunc((Number(toDate) - Number(fromDate)) / Utils.toMilliseconds(unit));
    };
    /**
     * fromDate inclusive, toDate exclusive when ignoreTime = true, when ignoreTime = false a day is 24 * 60 * 60 secs.
     */
    Utils.daysBetween = function (fromDate, toDate, opts) {
        var _a;
        if (opts === void 0) { opts = {}; }
        var negative = opts.notAbsolute && fromDate > toDate;
        if (fromDate > toDate) {
            _a = [fromDate, toDate], toDate = _a[0], fromDate = _a[1];
        }
        if (opts.ignoreTime) {
            fromDate = Utils.stripTime(fromDate);
            toDate = Utils.stripTime(toDate);
        }
        var offsetDelta = (fromDate.getTimezoneOffset() - toDate.getTimezoneOffset()) * Utils.toMilliseconds('mins');
        var days = Math.trunc((Number(toDate) - Number(fromDate) + offsetDelta) / Utils.toMilliseconds('days'));
        var result = opts.ignoreLeapDays ? days - Utils.leapDaysBetween(fromDate, toDate) : days;
        return negative ? result * -1 : result;
    };
    /**
     * fromDate inclusive, toDate exclusive; ignores time
     */
    Utils.leapDaysBetween = function (fromDate, toDate) {
        var _a;
        fromDate = Utils.stripTime(fromDate);
        toDate = Utils.stripTime(toDate);
        if (fromDate > toDate) {
            _a = [fromDate, toDate], toDate = _a[0], fromDate = _a[1];
        }
        var fromYear = fromDate.getFullYear();
        var toYear = toDate.getFullYear();
        var leapDays = 0;
        for (var yr = fromYear; yr <= toYear; yr++) {
            leapDays += Utils.isLeapYear(yr) ? 1 : 0;
        }
        var fromYrIsLeap = Utils.isLeapYear(fromYear);
        var toYrIsLeap = Utils.isLeapYear(toYear);
        if (fromYrIsLeap && fromDate.getTime() > new Date(fromYear, 1, 29).getTime()) {
            leapDays--;
        }
        if (toYrIsLeap && toDate.getTime() <= new Date(toYear, 1, 29).getTime()) {
            leapDays--;
        }
        return leapDays < 0 ? 0 : leapDays;
    };
    Utils.stripTime = function (dt) {
        return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
    };
    Utils.isLeapYear = function (year) {
        return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
    };
    Utils.daysInMonth = function (month, year) {
        return new Date(year, month, 0).getDate();
    };
    // @deprecated; use daysBetween
    Utils.daysBetweenIgnoreTime = function (fromDate, toDate) {
        return Utils.daysBetween(fromDate, toDate, { ignoreTime: true, ignoreLeapDays: false });
    };
    Utils.getCurrentMidYearDate = function (anniversaryDate, asOfDate) {
        asOfDate = asOfDate || Utils.now();
        var lastAnnDt = new Date(Date.UTC(asOfDate.getUTCFullYear(), anniversaryDate.getUTCMonth(), anniversaryDate.getUTCDate(), anniversaryDate.getUTCHours(), anniversaryDate.getUTCMinutes(), anniversaryDate.getUTCSeconds(), anniversaryDate.getUTCMilliseconds())), nextAnnDt = lastAnnDt;
        if (lastAnnDt > asOfDate) {
            lastAnnDt = Utils.offsetDate(lastAnnDt, -1, 'years');
        }
        else {
            nextAnnDt = Utils.offsetDate(nextAnnDt, 1, 'years');
        }
        return Utils.offsetDate(lastAnnDt, Math.round(Utils.daysBetween(lastAnnDt, nextAnnDt) / 2), 'days');
    };
    Utils.getDayOfMonth = function (date, day, occurance) {
        var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        var daysneeded = day - firstDayOfMonth.getDay();
        if (daysneeded < 0) {
            daysneeded = daysneeded + 7;
        }
        var resultedDay = daysneeded + 1 + 7 * (occurance - 1);
        return new Date(date.getFullYear(), date.getMonth(), resultedDay);
    };
    Utils.isInWeekend = function (date) {
        var day = date.getDay();
        return day === 0 || day === 6;
    };
    Utils.getHolidays = function () {
        return Holidays_1.Holidays.map(function (holiday) {
            return Utils.tzDate(holiday.date).toYmd();
        });
    };
    // This returns a date object in Timezone time.
    // Ex: What would 10AM be in EST?
    Utils.getTargetDate = function (utcDate, targetTimezone) {
        var utcMs = Date.UTC(utcDate.getFullYear(), utcDate.getMonth(), utcDate.getDate(), utcDate.getHours(), utcDate.getMinutes(), utcDate.getSeconds(), utcDate.getMilliseconds());
        var utcDt = Utils.tzDate(new Date(utcMs), targetTimezone);
        var utcMsInTz = utcMs + Utils.milliseconds(utcDt.timezoneOffset(), 'mins');
        return new Date(utcMsInTz);
    };
    Utils.getBusinessDayOffsetByXDays = function (startFromDate, offset) {
        var startFrom;
        var offsetMinutes;
        if (startFromDate) {
            startFrom = startFromDate;
        }
        else {
            var estTime = Utils.tzDate(Utils.now(), 'America/New_York');
            offsetMinutes = estTime.timezoneOffset();
            startFrom = Utils.offsetTime(estTime.toDate(), offsetMinutes, 'mins');
        }
        var nextDay = startFromDate;
        var holidays = this.getHolidays();
        var offsetDay = (offset > 0) ? 1 : -1;
        while (offset !== 0) {
            nextDay = Utils.offsetDate(startFrom, offsetDay, 'days');
            while (this.isHolidayOrWeekend(nextDay, holidays)) {
                nextDay = Utils.offsetDate(nextDay, offsetDay, 'days');
            }
            offset -= offsetDay;
            startFrom = nextDay;
        }
        if (offsetMinutes) {
            nextDay = Utils.offsetTime(nextDay, -offsetMinutes, 'mins');
        }
        return nextDay;
    };
    Utils.overlapDaysOfDateIntervals = function (startDate1, endDate1, startDate2, endDate2, ignoreTime) {
        if (startDate1.getTime() > endDate1.getTime() || startDate2.getTime() > endDate2.getTime()) {
            throw new Error("startDate is after the endDate");
        }
        var maxStartDate = new Date(Math.max(startDate1.getTime(), startDate2.getTime()));
        var minEndDate = new Date(Math.min(endDate1.getTime(), endDate2.getTime()));
        var daysBetween = this.daysBetween(maxStartDate, minEndDate, { notAbsolute: true, ignoreTime: ignoreTime });
        return daysBetween > 0 ? daysBetween : 0;
    };
    Utils.isHolidayOrWeekend = function (theDate, holidays) {
        return Utils.isInWeekend(theDate) || holidays.indexOf(Utils.tzDate(theDate).toYmd()) > -1;
    };
    Utils.ipAddress = function () {
        var ifaces = os.networkInterfaces();
        var ip = _.find(_.flatten(_.values(ifaces)), {
            family: 'IPv4',
            internal: false
        });
        return ip ? ip.address : 'Unknown';
    };
    Utils.findInRange = function (data, value, inclusive) {
        for (var i = 0; i < data.length; i += 2) {
            if (value < data[i] || inclusive && value === data[i]) {
                return data[i + 1];
            }
        }
        return null;
    };
    Utils.generateUuid = function () {
        return uuid.v1();
    };
    Utils.formatFiveDigitZipcode = function (zipcodeToFormat) {
        if (!zipcodeToFormat) {
            return '';
        }
        if (zipcodeToFormat.length === 5) {
            return zipcodeToFormat;
        }
        return zipcodeToFormat.slice(0, 5);
    };
    Utils.array = function (obj) {
        return [].concat(obj || []);
    };
    Utils.cleanedArray = function (arr) {
        return _.uniq(_.filter(arr, function (item) {
            return item !== undefined && item !== null && item !== '';
        })).sort();
    };
    Utils.access = function (root, path, defaultValue) {
        path = (path.charAt(0) === '.') ? path.slice(1) : path;
        if (!Utils.exists(root)) {
            return defaultValue;
        }
        var current = root;
        var fields = path.split('.');
        for (var i = 0; i < fields.length; i++) {
            var fieldValue = current[fields[i]];
            if (Utils.exists(fieldValue)) {
                current = fieldValue;
            }
            else {
                return defaultValue;
            }
        }
        return current;
    };
    Utils.transformTemplate = function (templateName, data, ctx, options) {
        options = options || {};
        var templatePath = options.templatePath || _templatePath;
        return new Promise(function (resolve, reject) {
            try {
                resolve(fs.readFileSync(templatePath + templateName, {
                    encoding: 'utf-8'
                }));
            }
            catch (e) {
                reject(e);
            }
        })
            .then(buildTemplate);
        function buildTemplate(templateStr) {
            var bodyOnly = options.bodyOnly || false;
            var templStr = bodyOnly ? templateStr.match(/<body>([\s\S]*)<\/body>/im)[1] : templateStr;
            ctx = ctx || {};
            ctx.data = data;
            return _.template(templStr, {
                variable: 'ctx'
            })(ctx);
        }
    };
    Utils.group = function (arr, groupSize, callback) {
        var counter = 0, grp = [];
        Utils.array(arr).forEach(function (e) {
            if (counter < groupSize) {
                counter++;
                grp.push(e);
            }
            else {
                callback(grp);
                grp = [e];
                counter = 1;
            }
        });
        callback(grp);
    };
    Utils.hasIntersection = function (arr1, arr2, equalsFuncName, propertyName) {
        if (!arr1 || !arr2 || arr1.length === 0 || arr2.length === 0) {
            return false;
        }
        return check(arr1, arr2);
        function check(arr1, arr2) {
            var len1 = arr1.length;
            var len2 = arr2.length;
            var i = 0;
            var j = 0;
            for (i; i < len1; i++) {
                for (j; j < len2; j++) {
                    if (equalsFuncName) {
                        if (arr1[i][equalsFuncName](arr2[j])) {
                            return true;
                        }
                    }
                    if (propertyName) {
                        if (arr1[i][propertyName] === arr2[j][propertyName]) {
                            return true;
                        }
                    }
                    if (arr1[i] === arr2[j]) {
                        return true;
                    }
                }
            }
            return false;
        }
    };
    Utils.union = function (arr1, arr2, equalsFuncName) {
        if (!arr1 || arr1.length === 0) {
            return Utils.uniq(arr2, equalsFuncName);
        }
        if (!arr2 || arr2.length === 0) {
            return Utils.uniq(arr1, equalsFuncName);
        }
        return Utils.uniq(_.union(arr1, arr2), equalsFuncName);
    };
    Utils.uniq = function (arr, equalsFuncName) {
        if (equalsFuncName) {
            return arr.reduce(function (uniqArr, item) {
                var matched = uniqArr.reduce(function (matched, uniqItem) {
                    return matched || uniqItem[equalsFuncName](item);
                }, false);
                if (!matched) {
                    uniqArr.push(item);
                }
                return uniqArr;
            }, []);
        }
        return arr.filter(function (item, idx) { return arr.indexOf(item) === idx; });
    };
    Utils.fillProperties = function (firstObj, secondObj, properties) {
        return _.reduce(properties, function (obj, property) {
            var firstObjProperty = obj && obj[property];
            var secondObjProperty = secondObj && secondObj[property];
            if (!firstObjProperty || Utils.array(firstObjProperty).length === 0 && secondObjProperty && Utils.array(secondObjProperty).length !== 0) {
                obj[property] = secondObjProperty;
            }
            return obj;
        }, firstObj);
    };
    Utils.toCamelCase = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var str = [].map.call(args, function (str) {
            return str.trim();
        }).filter(function (str) {
            return str.length;
        }).join('-');
        if (!str.length) {
            return '';
        }
        if (str.length === 1) {
            return str;
        }
        if (!/[_.\- ]+/.test(str)) {
            if (str === str.toUpperCase()) {
                return str.toLowerCase();
            }
            if (str[0] !== str[0].toLowerCase()) {
                return str[0].toLowerCase() + str.slice(1);
            }
            return str;
        }
        return str.replace(/^[_.\- ]+/, '').toLowerCase().replace(/[_.\- ]+(\w|$)/g, function (_m, p1) {
            return p1.toUpperCase();
        });
    };
    Utils.lastElementOfString = function (str, splitBy) {
        var elements = str.split(splitBy);
        return elements[elements.length - 1];
    };
    Utils.toCapitalizedWords = function (str) {
        if (!str) {
            return '';
        }
        // Separate words by spaces, tabs, or newlines.
        var words = str.split(/[\s\t\n\r]+/).filter(function (word) {
            return word.length > 0;
        }).map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        });
        return words.join(' ');
    };
    Utils.parseCityStateZipFromAddressLine = function (line) {
        var pattern = /([\w\s]+)[,\s]+(\w\w)[,\s]+(\d{5}(-\d{4})?)\s*/;
        var address = typeof line === 'string' ? line.trim().match(pattern) : null;
        return address ? {
            city: address[1],
            state: address[2],
            zip: address[3].replace(/-/g, '')
        } : null;
    };
    Utils.formatPhoneNumber = function (numberString) {
        if (!numberString) {
            return '';
        }
        var len = numberString.length;
        if (len === 10) {
            return format10DigitPhoneNumber(numberString);
        }
        else if (len === 11) {
            // Country code prefix
            return '+' + numberString.charAt(0) + ' ' + format10DigitPhoneNumber(numberString.slice(1));
        }
        else {
            return '';
        }
        function format10DigitPhoneNumber(numberString) {
            return '(' + numberString.slice(0, 3) + ') ' + numberString.slice(3, 6) + '-' + numberString.slice(6);
        }
    };
    Utils.formatTelephone = function (value) {
        if (!value) {
            return '';
        }
        var parts = value.split(' ');
        if (parts[0].length < 10) {
            return value;
        }
        return '(' + parts[0].substr(0, 3) + ') ' + parts[0].substr(3, 3) + '-' + parts[0].substr(6, 4) + (parts[1] && parts[1].length > 0 ? ' x' + parts[1] : '');
    };
    Utils.formatDate = function (value) {
        if (!value) {
            return '';
        }
        return value.getMonth() + 1 + '/' + value.getDate() + '/' + value.getFullYear();
    };
    Utils.toCapitalCamelCase = function (str) {
        var camelCased = Utils.toCamelCase(str);
        return camelCased.charAt(0).toUpperCase() + camelCased.slice(1);
    };
    Utils.sparseArraytoString = function (stringParts, separator) {
        separator = separator || ', ';
        return stringParts.filter(function (part) {
            return !!part;
        }).join(separator);
    };
    Utils.repeat = function (chars, times) {
        return Array(times + 1).join(chars);
    };
    Utils.formatNumber = function (value, precision) {
        if (precision === void 0) { precision = 0; }
        if (value === null) {
            return '';
        }
        value = Utils.round(value, precision);
        var x = value.toString().split('.');
        precision = precision || Number(x[1]) && x[1].length;
        var x1 = x[0], x2 = '';
        if (precision > 0) {
            x[1] = x[1] || '';
            _(precision - x[1].length).times(function () {
                x[1] += '0';
            });
            x2 = '.' + x[1];
        }
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    };
    Utils.formatOrdinalNumber = function (num) {
        if (num !== Math.round(num)) {
            return '';
        }
        var units = num % 10;
        var tens = num % 100;
        var ordinal = ['th', 'st', 'nd', 'rd'];
        return tens > 9 && tens < 20 ? "".concat(num, "th") : "".concat(num).concat(ordinal[units] || 'th');
    };
    Utils.formatCurrency = function (value) {
        if (value === null) {
            return '';
        }
        var roundedValue = Utils.round(Number(value), 2);
        return '$' + Utils.formatNumber(roundedValue, 2);
    };
    Utils.formatIntCurrency = function (value) {
        if (value === null) {
            return '';
        }
        var roundedValue = this.round(Number(value), 0);
        return '$' + Utils.formatNumber(roundedValue);
    };
    Utils.yesNo = function (value) {
        if (String(value).match(/^(true|yes)$/i)) {
            return 'Yes';
        }
        else if (String(value).match(/^(false|no)$/i)) {
            return 'No';
        }
        else if (value === undefined || value === null) {
            return '[No Data]';
        }
        else {
            return value.toString();
        }
    };
    Utils.replace = function (origString, badSubstring, replacementSubstring) {
        if (!origString || !badSubstring) {
            return origString;
        }
        replacementSubstring = replacementSubstring || '';
        return origString.replace(new RegExp(badSubstring, 'g'), replacementSubstring);
    };
    /**
     * Returns the rounded value of a number, given a precision.
     *
     * @remarks
     *  Positive numbers are rounded up on 1/2 values.
     *  Negative numbers are rounded away from 0 on 1/2 values.
     *
     * @param num - The number to be rounded
     * @param precision - The precision the number is to be rounded to
     * @returns The rounded value of the num param
     *
    */
    Utils.round = function (num, precision) {
        return Number((0, big_js_1.Big)(num).round(precision));
    };
    Utils.encrypt = function (text, algorithm, key) {
        var cipher = crypto.createCipher(algorithm, key);
        var encText = cipher.update(text, 'utf8', 'base64');
        return encText + cipher.final('base64');
    };
    Utils.decrypt = function (encText, algorithm, key) {
        var cipher = crypto.createDecipher(algorithm, key);
        var text = cipher.update(encText, 'base64', 'utf8');
        return text + cipher.final('utf8');
    };
    Utils.visitFiles = function (path, callback, dirFirst) {
        try {
            fs.statSync(path).isDirectory() ? visitDir() : callback(path, true);
        }
        catch (e) {
            // Ignore
        }
        function visitDir() {
            if (dirFirst) {
                callback(path, false);
            }
            fs.readdirSync(path).forEach(function (file) {
                Utils.visitFiles(path + '/' + file, callback, dirFirst);
            });
            if (!dirFirst) {
                callback(path, false);
            }
        }
    };
    Utils.writeFile = function (dirPath, fileName, fileContents) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Utils.makeDir(dirPath)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                fs.writeFile(Path.join(dirPath, fileName), fileContents, function (err) {
                                    err ? reject(err) : resolve();
                                });
                            })];
                }
            });
        });
    };
    Utils.deleteDir = function (path) {
        path = Path.join(path);
        if (os.platform() === 'win32') {
            return Utils.forkExec('rd /s /q ' + path);
        }
        else {
            return Utils.forkExec('rm -rf ' + path);
        }
    };
    Utils.makeDir = function (path) {
        path = Path.join(path);
        if (os.platform() === 'win32') {
            return Utils.forkExec('md ' + path);
        }
        else {
            return Utils.forkExec('mkdir -p ' + path);
        }
    };
    Utils.forkExec = function (cmd, opts, callback) {
        return new Promise(function (resolve, reject) {
            (0, child_process_1.exec)(cmd, opts || {}, function (error, stdout, stderr) {
                var decoder = new string_decoder_1.StringDecoder('utf8');
                Utils.logger.debug('forkExec', '', { cmd: cmd, opts: opts });
                if (callback) {
                    callback(resolve, error, stdout, stderr);
                }
                else if (error) {
                    Utils.logger.error('forkExec', '', error);
                    reject(error);
                }
                else {
                    Utils.logger.debug('forkExec', '', {
                        stdout: decoder.write(stdout),
                        stderr: decoder.write(stderr)
                    });
                    resolve({
                        stdout: decoder.write(stdout),
                        stderr: decoder.write(stderr)
                    });
                }
            });
        });
    };
    Utils.toString = function (error) {
        if (error) {
            return error instanceof WrappedError_1.WrappedError ? formatError(error.sourceError, error.message) : formatError(error);
        }
        return '';
        function formatError(error, message) {
            message = message || error.message || '';
            return message + '\n' + (error.stack ? error.stack : error.toString());
        }
    };
    Utils.endTimer = function (startTime, unit) {
        var div = unit && unit.match(/^secs?$/i) ? 1e9 : 1e6;
        var time = process.hrtime(startTime);
        return (time[0] * 1e9 + time[1]) / div;
    };
    Utils.average = function (arr) {
        var count = 0;
        var sum = (arr = arr || []).reduce(function (sum, n) {
            n = n || n === 0 ? Number(n) : undefined;
            if (isNaN(n)) {
                return sum;
            }
            count++;
            return sum + n;
        }, 0);
        return count > 0 ? sum / count : null;
    };
    Utils.sum = function (array) {
        array = Utils.array(array);
        return array.reduce(function (sum, n) {
            n = Number(n);
            return sum + (n || 0);
        }, 0);
    };
    Utils.base64 = function (data, encode) {
        if (encode) {
            return new Buffer(data).toString('base64');
        }
        else {
            return new Buffer(data, 'base64').toString('ascii');
        }
    };
    Utils.getParameterByName = function (name, url) {
        if (!url) {
            url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        var results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };
    Utils.isTestMode = function (testMode, testModes) {
        return Utils.isRunMode('test', testMode, testModes);
    };
    Utils.isPilotMode = function (pilotMode) {
        return Utils.isRunMode('pilot', pilotMode);
    };
    Utils.getEnv = function () {
        return amorphic_1.amorphicStatic.config.nconf.get('environment').trim();
    };
    Utils.isCiEnv = function () {
        return Utils.getEnv().match(/^ci(\s*:\s*(.*))?$/i) !== null;
    };
    Utils.isDemoEnv = function () {
        return Utils.getEnv().match(/^demo(\s*:\s*(.*))?$/i) !== null;
    };
    Utils.isUatEnv = function () {
        return Utils.getEnv().match(/^uat(\s*:\s*(.*))?$/i) !== null;
    };
    Utils.isProdEnv = function () {
        return Utils.getEnv().match(/^production(\s*:\s*(.*))?$/i) !== null;
    };
    Utils.moveTimeBy = function (offset, unit) {
        return Utils.addCurrentTimeOffset(offset, unit);
    };
    Utils.moveTimeForwardTo = function (hours, mins, timezone) {
        var offsetTargetTime = Utils.toLocalTimezone({ hour: hours, minute: mins, second: 0, ms: 0, timezone: timezone });
        if (offsetTargetTime.getTime() < Utils.now().getTime()) {
            offsetTargetTime.setDate(offsetTargetTime.getDate() + 1);
        }
        var diff = Utils.timeDiff(offsetTargetTime, Utils.now());
        return Utils.addCurrentTimeOffset(diff);
    };
    Utils.moveTimeBackwardTo = function (hours, mins, timezone) {
        var offsetTargetTime = Utils.toLocalTimezone({ hour: hours, minute: mins, second: 0, ms: 0, timezone: timezone });
        if (offsetTargetTime.getTime() > Utils.now().getTime()) {
            offsetTargetTime.setDate(offsetTargetTime.getDate() - 1);
        }
        var diff = Utils.timeDiff(offsetTargetTime, Utils.now());
        return Utils.addCurrentTimeOffset(diff);
    };
    Utils.toLocalTimezone = function (targetTime, localDate) {
        if (localDate === void 0) { localDate = Utils.now(); }
        var targetTimezone = targetTime.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
        var localTime = Utils.toTargetTimezone(localDate, targetTimezone);
        localTime = Utils.extend(localTime, targetTime);
        return moment.tz(localTime, targetTimezone).toDate();
    };
    Utils.toTargetTimezone = function (localTime, targetTimezone) {
        var targetTz = Utils.tzDate(localTime, targetTimezone);
        var diffMins = localTime.getTimezoneOffset() + targetTz.timezoneOffset();
        var targetTime = new Date(localTime.getTime() + (diffMins * 60000));
        return {
            year: targetTime.getFullYear(),
            month: targetTime.getMonth(),
            date: targetTime.getDate(),
            hour: targetTime.getHours(),
            minute: targetTime.getMinutes(),
            second: targetTime.getSeconds(),
            ms: targetTime.getMilliseconds(),
            timezone: targetTimezone
        };
    };
    Utils.setCurrentTimeOffset = function (offset, unit) {
        Utils.resetCurrentTime();
        Utils.addCurrentTimeOffset(offset, unit);
    };
    Utils.addCurrentTimeOffset = function (offset, unit) {
        if (Utils.isTestMode() && offset) {
            Utils._currentTimeOffset += Utils.milliseconds(offset, unit);
            Utils.logger.debug('addCurrentTimeOffset', 'Current time moved', { timeMovedTo: Utils.now() });
        }
    };
    Utils.resetCurrentTime = function () {
        Utils._currentTimeOffset = 0;
    };
    Utils.toBase64 = function (data) {
        return Utils.base64(data, true);
    };
    Utils.fromBase64 = function (data) {
        return Utils.base64(data, false);
    };
    Utils.getChannelName = function (channel) {
        var channelName = channel.toLowerCase();
        channelName = channelName === 'mmdirect' ? 'mm-direct' : channelName;
        return channelName === 'haven' ? 'customer' : channelName;
    };
    Utils.silenceAU = function (channel) {
        var channelName = Utils.getChannelName(channel);
        return amorphic_1.amorphicStatic.config.configStore[channelName].get('silenceAU');
    };
    Utils.trim = function (value) {
        return typeof value === 'string' ? value.trim() : value;
    };
    Utils.jsonToUrlParameters = function (json) {
        if (!json || typeof json !== 'object') {
            return '';
        }
        return Object.keys(json).map(function (key) {
            var value = json[key];
            if (!value) {
                value = '';
            }
            return encodeURIComponent(key) + '=' + encodeURIComponent(value);
        }).join('&');
    };
    Utils.getMillimanMibData = function (doc) {
        return doc && doc.IntelRX && doc.IntelRX.IntelRXResponse && doc.IntelRX.IntelRXResponse.Order && doc.IntelRX.IntelRXResponse.Order.Application && doc.IntelRX.IntelRXResponse.Order.Application.Applicant && doc.IntelRX.IntelRXResponse.Order.Application.Applicant.MIB;
    };
    Utils.calculateBmi = function (weightLbs, heightInches) {
        return Math.floor(weightLbs / heightInches / heightInches * 703);
    };
    Utils.genPersistorId = function (row) {
        row.__id__ = 'persistor-' + row._template + '-' + row._id;
        return row;
    };
    Utils.requireEverywhere = function (moduleName) {
        return (typeof window !== 'undefined' && window[moduleName]) ||
            typeof require !== 'undefined' && require(moduleName);
    };
    Utils.enumObjToArray = function (enumObj, key) {
        var arr = [];
        _.each(enumObj, function (item) {
            var value = item && (item[key] || item.code);
            if (value) {
                arr.push(value);
            }
            else {
                Utils.logger.warn('enumObjToArray', 'Missing value from the Enum', { key: key });
            }
        });
        return arr;
    };
    Utils.delay = function (duration, units) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        setTimeout(resolve, duration * Utils.toMilliseconds(units));
                    })];
            });
        });
    };
    Utils.parseValueInRange = function (metadata, value, valueSeparator, conditionSeparator) {
        if (valueSeparator === void 0) { valueSeparator = /\s*:\s*/; }
        if (conditionSeparator === void 0) { conditionSeparator = /\s*,\s*/; }
        var dataMap = Utils._parseMap(metadata, valueSeparator, conditionSeparator);
        return Object.keys(dataMap)
            .reduce(function (val, rangeStr) {
            return val ||
                (Utils.isInRange(rangeStr, value) ? dataMap[rangeStr] : null);
        }, null) || dataMap[Utils.ELSE];
    };
    Utils.getMapKeys = function (metadata, valueSeparator, conditionSeparator) {
        if (valueSeparator === void 0) { valueSeparator = /\s*:\s*/; }
        if (conditionSeparator === void 0) { conditionSeparator = /\s*,\s*/; }
        var dataMap = Utils._parseMap(metadata, valueSeparator, conditionSeparator);
        return Object.keys(dataMap);
    };
    Utils._parseMap = function (str, valueSeparator, conditionSeparator) {
        if (str) {
            return str.split(conditionSeparator)
                .reduce(function (map, pair) {
                var pArr = pair.split(valueSeparator);
                map[pArr[0]] = pArr[1];
                return map;
            }, {});
        }
        else {
            return {};
        }
    };
    Utils.isInRange = function (str, val) {
        var range = (str || '').split(/\s*\.\.\s*/).map(function (n) {
            if (n === '') {
                return Infinity;
            }
            return Number(n);
        });
        if (range.length !== 2) {
            return false;
        }
        if (range[0] === Infinity) {
            range[0] = -Infinity;
        }
        val = Number(val);
        return range[0] <= val && val <= range[1];
    };
    Utils.formatLogError = function (error) {
        return (error instanceof WrappedError_1.WrappedError || error instanceof Error) ? Utils.toString(error) : JSON.stringify(error);
    };
    /**
     * adjusts the given inputStr to make its length equal to desiredLength
     * case: inputStr length > desiredLength -> get either the initial or last substring depending on trimFront
     * case: inputStr length < desiredLength -> concatenate spaces up to desiredLength depending on fillFront
     * @param str input string
     * @param desiredLength length of the output string
     * @param fillFront if true and str length < desiredLength, add spaces to front of str, else add to the back
     * @param trimFront if true and str length > desiredLength, get ending substring of str, else beginning
     * @param concatChar the char to concat to str up to desiredLength
     */
    Utils.adjustStringLength = function (str, desiredLength, fillFront, trimFront, concatChar) {
        if (concatChar === void 0) { concatChar = ' '; }
        var lengthDiff = str.length - desiredLength;
        if (lengthDiff === 0) {
            return str;
        }
        if (lengthDiff > 0) {
            if (trimFront) {
                return str.substring(lengthDiff, desiredLength + lengthDiff);
            }
            return str.substring(0, desiredLength);
        }
        var concatStr = '';
        for (var i = 0; i < Math.abs(lengthDiff); i++) {
            concatStr += concatChar;
        }
        if (fillFront) {
            return concatStr + str;
        }
        return str + concatStr;
    };
    Utils.ELSE = '_else_';
    Utils._currentTimeOffset = 0;
    Utils._listeningToShutdownSignals = false;
    Utils._shutdownHandlers = [];
    Utils.GEOLOCATION_API_NAME = 'GoogleMapsGeolocationAPI';
    Utils.TIMEZONE_API_NAME = 'GoogleMapsTimezoneAPI';
    Utils.DayOfWeek = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6
    };
    return Utils;
}());
exports.Utils = Utils;
//# sourceMappingURL=Utils.js.map